import { ProductListPage, ProductWithSpecification, Pagination, Product } from "Models/Products/ProductListPage";
import { FacetFilter, Option } from "Models/FacetFilter/FacetFilter";
import * as $ from "jquery";
import Vue from 'vue';
import Component from "vue-class-component";
import ABaseComponent from "Components/Base/ABaseComponent";
import productList from "Store/productList/productList";
import porterItems from "Store/porterItems/porterItems";
import { Prop, Watch } from "vue-property-decorator";
import { Client, PorterViewModel, GetPricesQueryArgs, IGetPricesQueryArgs, ICalculatedProductPrice, ProductPriceKey, IProductPriceKey, GetPorterItemListViewModel, PorterItemViewModel, GetPorterProductListItemsViewModel,PorterItemsSize } from "Api/CoreApi";
import ApiProvider from "Api/ApiProvider";
import porterBuilder from "Store/porterbuilder/porterbuilder";
import productVariantStore from "Store/productVariantStore/productVariantStore";
import porterBudgetStore from 'Store/porterBudget/porterBudget';
import { toUpper } from "lodash";
import { Specification } from "Models/Products/ProductListPage";
import { IPorterBudget, IPorter } from 'Api/CoreApi';
//import UserInformationComponent from "Components/Base/UserInformationComponent";
import axios from 'axios'
import { EventBus, EventBusEvents } from "Components/Base/EventBus";

@Component({})
export class ProductListComponent extends ABaseComponent {
    @Prop({ default: "" })
    pdpLink: string;

    @Prop()
    public isPorter: boolean;

    productToModify: string = "";
    productVariantToModify: string = "";

    public get needToPickSizes(): boolean {
        return Object.keys(porterItems.state.porterItemsMissingSize).length !== 0;
    }

    public setProductToModify(val: string, variant: string) {
        this.productToModify = val;
        this.productVariantToModify = variant;
    }

    public get ModifyProudct() {
        return this.productToModify !== ""; 
    }
    get budget() {
        return porterBudgetStore.state.porterBudget;
    }
    get porter() {
        return porterBudgetStore.state.porter;
    }
    

    porterList: PorterViewModel[] = null;

    get porterIdFromBuilder() {
        return porterBuilder.state.porterId;
    }


    get porterFromBuilder() {
        return porterBuilder.state.porter.porter;
    }

    get isBuilder() {
        return porterBuilder.state.porter ? true : false;
    }

    get porterHasFunctionCode() {
        return porterBuilder.state.porter.porter.functionCode ? true : false;
    }

    prices: ICalculatedProductPrice[] = [];
    
    specList: any = {};

    @Prop()
    languageId: string;
    get queryLoading() {
        return productList.state.isLoading;
    }

    private get query() {
        return productList.state.query;
    }

    getPrice(product: ProductWithSpecification):number {
        const foundPrice = this.prices.filter(x => x.productId === product.Product.Number)[0];
        if (!foundPrice) return 0;
        
        if (this.porter.hasBudget) {
            if (this.currentBudget.typePoints) {
                // Return found price 
                return foundPrice.extraInfo["BudgetPoints"];
            } else {
                // Return found points
                return foundPrice.extraInfo["BudgetPrice"];
            }
        }

        return 0;
    }

    public porterBuilderIncludePorterNo() {
        const urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.has("porterNo")) {
            urlParams.append("porterNo", porterBuilder.state.porter.porter.contactNo);
            const newUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
            window.location.href = newUrl;
        }
    }

    public porterBuilderExcludePorterNo() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("porterNo")) {
            urlParams.delete("porterNo");
            const newUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
            window.location.href = newUrl;
        }
    }

    get porterBuilderContainsPorterNo(): boolean {
        return window.location.href.includes("porterNo");
    }

    get porterBuilderModeActive() {
        return porterBuilder.state.porterId ? true : false;
    }

    public getSize(val: ProductWithSpecification) {
        const variants = porterItems.state.porterItemsSelectedSizes[val.Product.Number];
        if (!variants) return "";
        const variant = variants.find(x => x.variantNumber === val.Product.VariantId);
        return variant == null ? "" : variant.variantSize;
    }

    selectedSizes(itemNo: string): PorterItemsSize[] {
        return porterItems.state.porterItemsSelectedSizes[itemNo] != null
            ? porterItems.state.porterItemsSelectedSizes[itemNo] : [] as PorterItemsSize[] ;
    }


    get products(): ProductWithSpecification[] {
        if (!productList.state.productListPage || !productList.state.productListPage.Products) return [];
        if (! (this.isPorter && !this.isBuilder)) return productList.state.productListPage.Products;


        if (this.needToPickSizes) {
            var sizesToPick = porterItems.state.porterItemsMissingSize.map(x => x.product.itemNumber);
            return productList.state.productListPage.Products.filter(x => sizesToPick.includes(x.Product.Number)); 
        }

        if (this.ModifyProudct) {
            return productList.state.productListPage.Products.filter(x => x.Product.Number === this.productToModify);
        }

        const prods = []; 
        for (const product of productList.state.productListPage.Products) {
            const variants = this.selectedSizes(product.Product.Number);
            if (variants) {
                for (const variant of variants) {
                    const copy = JSON.parse(JSON.stringify(product));
                    copy.Product.VariantId = variant.variantNumber;
                    prods.push(copy);
                }
                
            }
        }
        return prods;
    }

    get pagination(): Pagination {
        if (productList.state.productListPage && productList.state.productListPage.Pagination)
            return productList.state.productListPage.Pagination;
        else
            return null;
    }
    get facetFilter(): FacetFilter[] {
        if (productList.state.productListPage && productList.state.productListPage.FacetFilter)
            return productList.state.productListPage.FacetFilter;
        else
            return null;
    }

    public getPorterListItem(number: string): PorterItemViewModel {

        return porterBuilder.state.porterItems.porterItems.find(x => x.porterItem.itemNo == number) || null;
    }

    get currentBudget(): IPorterBudget {
        return porterBudgetStore.state.porterBudget;
    }

    async created() {
        const client = ApiProvider.getApiClient();
        
        if (this.isPorter) {
            await porterBudgetStore.dispatchFetchPorterBudget();

            //this.porter = await UserInformationComponent.getPorter();
            //await porterBudgetStore.dispatchFetchPorterBudget({ porterContactNo: this.porter.contactNo });
            //this.budget = porterBudgetStore.state.currentPorterBudget;
        }
        await productList.dispatchSetProductQueryFromUrl();

        if (!this.porterList) {
            client.getPorterList().then(result => {
                this.porterList = result.porters;
                this.setLoaded();
            });
        }
    }


    findPorterReplacementItem(itemNo: string): string {
        if (porterBuilder.state.porterItems && porterBuilder.state.porterItems.porterItems) {
            let foundPorterItem = porterBuilder.state.porterItems.porterItems.find(x => x.porterItem.itemNo == itemNo);
            if (foundPorterItem) {
                return foundPorterItem.porterItem.replacementProductGroupCode;
            }

        }

        return '';
    }
    //Product id is the groupcode; nomatter what, you cant see the matrix on the PLP, even if the item is old model on porter.
    public allowAddToPorter(customerItem: Product) {
        if (!porterBuilder.state.porterItems && !porterBuilder.state.porterItems.porterItems)
            return true;

        const foundPorterItem = porterBuilder.state.porterItems.porterItems.find(x => x.porterItem.itemNo == customerItem.Number);
        if (foundPorterItem && porterBuilder.state.porterItems.porterItems && foundPorterItem.porterItem.isOldModelSales) {
            return false;
        } else if (!foundPorterItem && customerItem.IsOldModelSales) {
            return false;
        }
        return true;
    }
    get getPorterItems() {
        return porterBuilder.state.porterItems;
    }


    getSpecification(product: ProductWithSpecification, name: string): string {
        const target = product.Specifications.find(a => a.Key === name);
        if (target && target.Value !== "") {
            return target.Value;
        } else return null;

    }
    
    @Watch("products")
    async loadAllPrices() {
        const client = ApiProvider.getApiClient();

        const productKeys: ProductPriceKey[] = [];
        
        this.products.forEach(x => {
            var productKey = new ProductPriceKey({
                productId: x.Product.Number,
                unitOfMeasure: x.Specifications.filter(x => x.Key === "SalesUnitofMeasure")[0].Value,
                variantId: "",
            });

            productKeys.push(productKey);
        });
        const args = new GetPricesQueryArgs({ keys: productKeys });
        const priceResponse = await client.getPrices(args);
        this.prices = priceResponse.prices;
    }


    async hasVariants(product: ProductWithSpecification, languageId: string): Promise<boolean> {
        if (product.Product.HasVariants)
            return product.Product.HasVariants;
        else {
            this.setLoading();
            let hasVariants = false;
            let variantList = await productVariantStore.loadVariantCount({
                languageId: this.languageId,
                productId: product.Product.Id
            });
            hasVariants = variantList.length > 0;
            return hasVariants;
        }
    }

    getDefaultVariantId(product: ProductWithSpecification): string {
        return product.Product.DefaultVariantId;
    }

    getSpecPathOrDefault(product: ProductWithSpecification, spec: string, path: string, defaultValue: string) {
        spec = this.getSpecification(product, spec);
        return spec ? path + spec : defaultValue;

    }

    loadProductMatrix(productId: string) {
        this.$root.$emit("loadProductMatrix", productId);
    }

    get shouldShowProductList() {
        return this.products.length > 0; 
    }

    @Watch("isBuilder")
    @Watch("query")
    async loadProductList() {
        if (this.isPorter && !this.isBuilder) {
            // TODO: FIX THIS!!!
            //await porterBudgetStore.dispatchFetchPorterBudget();
            await porterItems.dispatchGetPorterItems({ languageId: this.languageId, porterId: this.porter.id });
            
            await productList.dispatchUpdatePorterProductListPage();
        }
        else if (this.isBuilder) {
            await productList.dispatchUpdateProductListPagePorterBuilder(this.porterFromBuilder.contactNo);
        }
        else {
            await productList.dispatchUpdateProductListPage(true);
        }
    }
}
Vue.component("product-list", ProductListComponent)